export const ENABLE_INQUIRY = 1;
export const DISABLE_INQUIRY_DUPLICATE = 2;
export const DISABLE_INQUIRY_MAXIMUM = 3;
export const ORDER_ERROR_MESSAGES = {
    [DISABLE_INQUIRY_DUPLICATE]: 'このプロジェクト事例は既に申し込み中です',
    [DISABLE_INQUIRY_MAXIMUM]: '5件より多く申し込むことはできません',
};
export const INQUIRY_TYPES_CANDIDATES = [
    { label: 'メール', value: 4 },
    { label: '電話', value: 2 },
    { label: 'Web会議', value: 3 },
    { label: '面談', value: 1 },
];
export const ORDER_TYPE_CANDIDATES = [
    { label: '提案が魅力的だった', value: 1 },
    { label: 'チームが好印象だった', value: 2 },
    { label: '予算・内容が希望にあった', value: 3 },
    { label: 'その他', other: true, value: 4 },
];
export const SEND_OFF_TYPE_CANDIDATES = [
    { label: '予算が合わなかった', value: 1 },
    { label: '時期が合わなかった', value: 2 },
    { label: '依頼内容がプロジェクト事例と違った', value: 3 },
    { label: 'その他', other: true, value: 4 },
];
